const TOKEN_REFRESH_INTERVAL = 14 * 60 * 1000;
const SESSION_CHECK_INTERVAL = 5 * 60 * 1000;

export { TOKEN_REFRESH_INTERVAL, SESSION_CHECK_INTERVAL };
